// Only update fields that are currently empty to avoid overwriting existing data
export const getAddressPrefillData = (addressData, currentAddressData) => {
  const addressUpdate = {}

  if (!currentAddressData.streetName && addressData.address) {
    addressUpdate.streetName = addressData.address
  }
  if (!currentAddressData.streetNumber && addressData.streetNumber) {
    addressUpdate.streetNumber = addressData.streetNumber
  }
  if (!currentAddressData.city && addressData.city) {
    addressUpdate.city = addressData.city
  }
  if (!currentAddressData.zipcode && addressData.zipcode) {
    addressUpdate.zipcode = addressData.zipcode
  }
  if (!currentAddressData.inseeCode && addressData.inseeCode) {
    addressUpdate.inseeCode = addressData.inseeCode
  }
  if (!currentAddressData.label && addressData.label) {
    addressUpdate.label = addressData.label
  }

  return addressUpdate
}
